import { render } from "./LanguageSelector.vue?vue&type=template&id=17dc51a6"
import script from "./LanguageSelector.vue?vue&type=script&lang=js"
export * from "./LanguageSelector.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/newsletter.norden.org/releases/74710130/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__